// extracted by mini-css-extract-plugin
export default {"container":"eZ-z","list":"fZ-z"};